export const smallHeight=815
export const mobileWidth=600